function copyToClipboard(button) {
  // Find the code block related to the button
  const codeBlock = button.previousElementSibling.querySelector('code').textContent;

  // Copy the code block text to clipboard
  navigator.clipboard.writeText(codeBlock).then(() => {
    alert("Code copied to clipboard!");
  }).catch(err => {
    console.error('Failed to copy: ', err);
  });
}

// Function to add a close button and hide the element on click
function addCloseButtonToMessages() {
  // Select all message elements
  const messages = document.querySelectorAll('[data-drupal-messages] .messages__wrapper .messages');

  messages.forEach(function(message) {
    // Create the close button
    const closeButton = document.createElement('button');
    closeButton.innerHTML = '&times;'; // X symbol for close button
    closeButton.classList.add('close-button'); // Add class for styling
    closeButton.style.position = 'absolute';
    closeButton.style.right = '10px';
    closeButton.style.top = '10px';
    closeButton.style.cursor = 'pointer';
    closeButton.style.background = 'transparent';
    closeButton.style.border = 'none';
    closeButton.style.fontSize = '20px';

    // Append the close button to the message element
    message.appendChild(closeButton);

    // Add click event to remove the message when close button is clicked
    closeButton.addEventListener('click', function() {
      message.closest('[data-drupal-messages]').remove(); // Remove the entire message element
    });
  });
}

// Call the function to add the close button when the document is ready
document.addEventListener('DOMContentLoaded', addCloseButtonToMessages);
